import React from 'react';
import { TableBody, TableCell, TableRow } from '@mui/material';

import { useCCTableContext } from '../cc-table.context';

export const CCTableBody = () => {
  const { columns, paginatedRows } = useCCTableContext();

  return (
    <TableBody>
      {paginatedRows.map((row, rowIndex) => {
        return (
          <TableRow key={`cc-table-row-${rowIndex}`} hover role="checkbox" selected={false} onClick={() => {}}>
            {
              // eslint-disable-next-line
              columns.map(({ id, sorter, filter, mobileSx, render, ...rest }, colIndex) => {
                return (
                  <TableCell key={`cc-table-row-${rowIndex}-col-${colIndex}`} {...rest}>
                    {render ? render(row) : row[id]}
                  </TableCell>
                );
              })
            }
          </TableRow>
        );
      })}
    </TableBody>
  );
};
